(function () {
  var THEME_STORAGE_KEY = 'header-lola-theme';

  document.querySelectorAll('[data-header-main-lola]').forEach(function (header) {
    initTheme(header);
    initSound(header);
    initOverlay(header);
    initScrollState(header);
    initLocaleSelector(header);
    alignLocaleWithBuyButton(header);
  });

  // Fixed + translucent main bar on scroll: stays in normal flow (looks
  // exactly as at rest) until the very first pixel of scroll, at which
  // point it switches to position:fixed with a slight transparency +
  // blur (see CSS, [data-scrolled]). The announcement bar above it is
  // deliberately left alone — it just scrolls away normally, only the
  // main bar reacts.
  function initScrollState(header) {
    var main = header.querySelector('.header-main-lola__main');
    var spacer = header.querySelector('[data-header-main-lola-main-spacer]');
    if (!main) return;

    var isScrolled = false;
    var ticking = false;

    function syncSpacerHeight() {
      if (spacer) spacer.style.height = main.offsetHeight + 'px';
    }

    function applyState() {
      var shouldBeScrolled = window.scrollY > 0;
      if (shouldBeScrolled === isScrolled) return;
      isScrolled = shouldBeScrolled;

      if (isScrolled) {
        // Measure and lock in the spacer's height BEFORE the bar leaves
        // the flow, so the page content below never jumps.
        syncSpacerHeight();
        header.setAttribute('data-scrolled', '');
      } else {
        header.removeAttribute('data-scrolled');
        if (spacer) spacer.style.height = '0px';
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        applyState();
        ticking = false;
      });
    }

    // In case the bar's own height changes while already scrolled (e.g.
    // a viewport resize/orientation change alters its padding).
    window.addEventListener('resize', function () {
      if (isScrolled) syncSpacerHeight();
    });

    applyState();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initTheme(header) {
    var toggles = header.querySelectorAll('[data-header-main-lola-theme-toggle]');
    if (!toggles.length) return;

    var saved = null;
    try {
      saved = window.localStorage.getItem(THEME_STORAGE_KEY);
    } catch (e) {
      saved = null;
    }

    applyTheme(saved === 'night' ? 'night' : 'light');

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var current = header.getAttribute('data-theme');
        var next = current === 'night' ? 'light' : 'night';
        applyTheme(next);
        try {
          window.localStorage.setItem(THEME_STORAGE_KEY, next);
        } catch (e) {
          /* localStorage not available, ignore */
        }
      });
    });

    function applyTheme(theme) {
      header.setAttribute('data-theme', theme);
      // Mirrored onto <html> so every other section on the page can
      // react to the same toggle via a plain
      // "html[data-theme='night'] .section {...}" CSS rule.
      document.documentElement.setAttribute('data-theme', theme);

      var labelDay = header.getAttribute('data-label-day') || 'AFTER DARK';
      var labelNight = header.getAttribute('data-label-night') || 'GOLDEN HOURS';
      var labels = header.querySelectorAll('[data-header-main-lola-theme-label]');
      labels.forEach(function (label) {
        label.textContent = theme === 'night' ? labelNight : labelDay;
      });

      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-pressed', theme === 'night' ? 'true' : 'false');
      });
    }
  }

  // Play/pause Lola's song — identical pattern to header-lola: a single
  // shared <audio>, kept in sync purely off the audio's own play/pause
  // events rather than whichever control triggered it.
  function initSound(header) {
    var audio = header.querySelector('[data-header-main-lola-audio]');
    var toggles = header.querySelectorAll('[data-header-main-lola-sound-toggle]');
    if (!audio || !toggles.length) return;

    var labelPlay = header.getAttribute('data-sound-label-play') || "Play Lola's song";
    var labelPause = header.getAttribute('data-sound-label-pause') || "Pause Lola's song";

    function setPlaying(isPlaying) {
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-pressed', isPlaying ? 'true' : 'false');
        toggle.setAttribute('aria-label', isPlaying ? labelPause : labelPlay);
      });
    }

    audio.addEventListener('play', function () {
      setPlaying(true);
    });

    audio.addEventListener('pause', function () {
      setPlaying(false);
    });

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (audio.paused) {
          audio.play().catch(function () {
            /* Playback can still fail (e.g. no user-gesture context in
               some embedded views) — fail silently, toggle stays off. */
          });
        } else {
          audio.pause();
        }
      });
    });
  }

  // Curtain overlay: toggled by the hamburger/X button. "data-menu-open"
  // on the header root drives everything visual (curtain drop, header
  // bar going transparent, text/icons switching to creme) — this
  // function's only job is to keep that attribute, aria-expanded, the
  // overlay's aria-hidden, and body scroll locking all in sync.
  function initOverlay(header) {
    var toggle = header.querySelector('[data-header-main-lola-menu-toggle]');
    var overlay = header.querySelector('[data-header-main-lola-overlay]');
    if (!toggle || !overlay) return;

    var links = overlay.querySelectorAll('[data-header-main-lola-overlay-link]');
    var labelOpen = header.getAttribute('data-menu-label-open') || 'Open menu';
    var labelClose = header.getAttribute('data-menu-label-close') || 'Close menu';

    function open() {
      header.setAttribute('data-menu-open', '');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', labelClose);
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      header.removeAttribute('data-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', labelOpen);
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') close();
    }

    toggle.addEventListener('click', function () {
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        close();
      } else {
        open();
      }
    });

    // Navigating via a menu link closes the curtain rather than leaving
    // it open underneath the next page's own header state.
    links.forEach(function (link) {
      link.addEventListener('click', close);
    });
  }
  // Locale selector: componente propio (botón + lista), reemplaza al
  // <select> nativo — la lista desplegable nativa del navegador no se
  // puede estilizar (fondo, esquinas redondeadas, separadores). Dos
  // instancias independientes pueden existir (franja de anuncio +
  // fila de utilidades del overlay móvil, mismo patrón que el toggle de
  // tema/sonido), así que recorre todas las que encuentre. Cada opción
  // es un <button type="submit"> con su propio name/value — al hacer
  // clic se envía SOLO ese campo, de forma nativa, sin necesitar ningún
  // truco para evitar mandar el otro campo sin querer (a diferencia del
  // <select> compartido de antes, que sí mandaba los dos a la vez y
  // causaba el bug de "siempre vuelve a Alemania"). Mismas convenciones
  // de apertura/cierre que el resto del proyecto (aria-expanded,
  // Escape, clic afuera).
  function initLocaleSelector(header) {
    var combos = Array.prototype.slice.call(header.querySelectorAll('[data-header-main-lola-locale-combo]'));
    if (!combos.length) return;

    combos.forEach(function (combo) {
      var toggle = combo.querySelector('[data-header-main-lola-locale-combo-toggle]');
      var list = combo.querySelector('[data-header-main-lola-locale-combo-list]');
      if (!toggle || !list) return;

      function close() {
        list.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        document.removeEventListener('keydown', onKeydown);
        document.removeEventListener('click', onDocumentClick);
      }

      function open() {
        // Solo un combo abierto a la vez — cierra cualquier otro que ya
        // estuviera abierto en este mismo header (incluye ambas
        // instancias, franja y overlay, aunque en la práctica solo una
        // de las dos es visible a la vez según el ancho de pantalla).
        combos.forEach(function (other) {
          if (other === combo) return;
          var otherToggle = other.querySelector('[data-header-main-lola-locale-combo-toggle]');
          var otherList = other.querySelector('[data-header-main-lola-locale-combo-list]');
          if (otherList) otherList.hidden = true;
          if (otherToggle) otherToggle.setAttribute('aria-expanded', 'false');
        });

        list.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
        document.addEventListener('keydown', onKeydown);
        document.addEventListener('click', onDocumentClick);
      }

      function onKeydown(event) {
        if (event.key === 'Escape') {
          close();
          toggle.focus();
        }
      }

      function onDocumentClick(event) {
        if (!combo.contains(event.target)) close();
      }

      toggle.addEventListener('click', function () {
        var isOpen = toggle.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          close();
        } else {
          open();
        }
      });
    });
  }

  // Alinea el borde izquierdo del dropdown de país/idioma (franja de
  // anuncio) con el borde izquierdo real del botón "JETZT KAUFEN" de la
  // barra principal, de abajo. No existe ningún valor fijo en CSS que
  // sirva para esto: el botón cambia de ancho según el idioma activo (el
  // texto se traduce), y también podría no existir en absoluto (campo
  // vacío en el schema) — en ese caso se usa el ícono del carrito como
  // referencia en su lugar, el primer elemento visible de esa fila. Se
  // mide con getBoundingClientRect() en vez de asumir nada, y se vuelve
  // a medir en cada resize por si el ancho del botón cambia al pasar de
  // mobile a desktop o viceversa (aunque el propio dropdown ya está
  // oculto en mobile vía CSS, medir de más no rompe nada).
  function alignLocaleWithBuyButton(header) {
    var localeForm = header.querySelector('.header-main-lola__announcement .header-main-lola__locale-form');
    if (!localeForm) return;

    var referenceEl = header.querySelector('.header-main-lola__buy-btn') || header.querySelector('[data-header-main-lola-cart-trigger]');
    if (!referenceEl) return;

    function sync() {
      // Se resetea a 0 ANTES de medir — si no, cada re-medición (en
      // cada resize) arrastraría el offset ya aplicado la vez anterior,
      // sumándolo sobre sí mismo en vez de recalcularlo desde cero.
      localeForm.style.marginLeft = '0px';

      var formLeft = localeForm.getBoundingClientRect().left;
      var refLeft = referenceEl.getBoundingClientRect().left;
      var offset = refLeft - formLeft;

      // Nunca negativo: si por alguna razón el botón de referencia
      // terminara más a la izquierda que la posición natural del
      // dropdown (pantallas muy angostas, por ejemplo), no tiene
      // sentido un margen negativo que lo empuje fuera de la franja.
      localeForm.style.marginLeft = Math.max(0, offset) + 'px';
    }

    sync();
    window.addEventListener('resize', sync);
  }
})();
